export default __webpack_public_path__ + "static/icons-01-02-5b3634f0a0e69e08b983f8b35f6298ea.png";